import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Route, Routes, useLocation } from "react-router-dom";

import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import PrivacyPage from "./pages/PrivacyPage";
import PublicationPage from "./pages/PublicationPage";

import { MAIN_ROUTES } from "./utils/routes";

function App() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{t("WEBPAGE_TITLE")}</title>

        <meta name="description" content={t("WEBPAGE_DESCRIPTION")} />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Kulim+Park&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <Box
        sx={{
          cursor: "default",
          minHeight: "100vh",
          overflowX: { xs: "hidden", sm: "hidden", md: "clip" },
          // pt: `${appBar.height}px`,
          width: "100%",
        }}
      >
        <Routes>
          <Route path={MAIN_ROUTES.get("HOME").PATH} element={<HomePage />} />

          <Route path={MAIN_ROUTES.get("ABOUT").PATH} element={<AboutPage />} />

          <Route
            path={MAIN_ROUTES.get("PUBLICATIONS").PATH}
            element={<PublicationPage />}
          />

          <Route
            path={MAIN_ROUTES.get("CONTACT").PATH}
            element={<ContactPage />}
          />

          <Route
            path={MAIN_ROUTES.get("PRIVACY").PATH}
            element={<PrivacyPage />}
          />
        </Routes>

        <Footer />
      </Box>
    </HelmetProvider>
  );
}

export default App;
